import React from "react";
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";
import EditIcon from '@mui/icons-material/Edit';
import { formatDateTimeShort } from "../../../../../utils/textUtils"; // MODIFIED

const FixedLogsConfigTable = ({ data, onEdit, loading, currentPage, setCurrentPage }) => {
  const headers = ["ID", "Date From", "Date To", "Vessel", "Status", "Actions"];
  const accessors = ["id", "dateFromFormatted", "dateToFormatted", "vesselName", "statusDisplay", "actions"];

  const formattedData = data?.map(item => ({
    ...item,
    dateFromFormatted: formatDateTimeShort(item.dateFrom), // REPLACED
    dateToFormatted: formatDateTimeShort(item.dateTo),     // REPLACED
    statusDisplay: (
      <span style={{ fontWeight: 'bold', color: item.isActive ? '#16a34a' : '#dc2626' }}>
        {item.isActive ? "ON" : "OFF"}
      </span>
    ),
  }));

  const actions = [
    {
      name: "Edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: onEdit,
      visible: true,
    },
  ];

  return (
    <CreateTable
      tableName={"Fixed Logs Configuration"}
      headers={headers}
      accessors={accessors}
      data={formattedData}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data?.length}
    />
  );
};

export default FixedLogsConfigTable;